import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { DataContext } from '../context/data';

export const Deck = () => {


    const { dataAPI, isLoaded } = useContext(DataContext);
    console.log(dataAPI);


    
    if (isLoaded){

        function nbreStar(carte){
            let tabStar = [];
            for(let i = 0; i < carte.starLevel; i++){
                tabStar.push(<i className="material-icons" key={carte.id+i}>star</i>)
            }
        
            return tabStar
        }

        
    return (
        <div>
            <div className="row">
                <h2>Deck actuel</h2>
                {dataAPI.currentDeck.map(carte => {
                    return (
                        <div className="card col s4 l1" key={carte.id}>
                            <div className="card-image">
                                <img className='circle responsive-img' src={carte.iconUrls.medium} alt='imgCarte' />
                                <span className="card-title">{carte.name}</span>
                            </div>
                            <div className="card-content">
                                <p>level : {carte.level}</p>
                                <p>{nbreStar(carte)}</p>
                            </div>
                        </div>
                    )
                })}
            </div>
            <div className='row'>
                <h2>Carte favorite</h2>
            <div className="card col s4 l1" key={dataAPI.currentFavouriteCard.id}>
                            <div className="card-image">
                                <img className='circle responsive-img' src={dataAPI.currentFavouriteCard.iconUrls.medium} alt='imgCarte' />
                                <span className="card-title">{dataAPI.currentFavouriteCard.name}</span>
                            </div>
                            <div className="card-content">
                                <p>Level {dataAPI.currentFavouriteCard.maxLevel}</p>
                            </div>
                        </div>
               
            </div>
            <div className="row">
                <h2>Carte possédés</h2>
                {dataAPI.cards.map(carte => {
                    return (
                        <div className="card col s4 l1" key={carte.id}>
                            <div className="card-image">
                                <img className='circle responsive-img' src={carte.iconUrls.medium} alt='imgCarte' />
                                <span className="card-title">{carte.name}</span>
                            </div>
                            <div className="card-content">
                                <p>level : {carte.level}</p>
                                <p>Nombre : {carte.count}</p>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    );
}
else {
    return (
        <div>
            <Navigate replace to='/' />
        </div>
    )
}
};
